import Vue from 'vue';
import Router from 'vue-router';
import Idle from './views/Idle.vue';
import Prestaties from './views/Prestaties.vue';
import Groepslessen from './views/Groepslessen.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'idle',
            component: Idle
        },
        {
            path: '/prestaties',
            name: 'prestaties',
            component: Prestaties
        },
        {
            path: '/groepslessen',
            name: 'groepslessen',
            component: Groepslessen
        }
    ]
});
